module.exports = __webpack_public_path__ + "static/03-527df6325a53113613522e648f6c2d4c.jpg";